// src/context/provider/AuthProvider.tsx
import { useState } from "react";
import { AuthContext} from "../context/AuthContext";
import type { AuthUser } from "../context/AuthContext";

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [user, setUser] = useState<AuthUser | null>(null);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {children}
        </AuthContext.Provider>
    );
};
